export let path = 'prod';
export const KEYDATA = 'loren-heyw';

